export const BedrockAssistantRoute = {
  path: '/bedrock-assistant',
  load: () => import('./pages/Assistant'),
  protected: true,
};
